"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58705],{

/***/ 429906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(225956);
var coreRenderer = __webpack_require__(327723);
var Container = __webpack_require__(739890);
var renderDynamicSlot = __webpack_require__(744175);
var EmptyProduct = __webpack_require__(867118);
var grid = __webpack_require__(793767);
var getStyles = __webpack_require__(523340);
var BlockHeader = __webpack_require__(177530);
var renderLink = __webpack_require__(62534);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LeftBannerProduct = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    ssrData
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData"
  ]);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    collectionSlug,
    viewMoreUrl,
    title,
    commonStyle,
    titleStyle,
    viewMoreStyle,
    showTwoProductRows,
    topBanner,
    bottomBanner
  } = _a2, rest = __objRest(_a2, [
    "collectionSlug",
    "viewMoreUrl",
    "title",
    "commonStyle",
    "titleStyle",
    "viewMoreStyle",
    "showTwoProductRows",
    "topBanner",
    "bottomBanner"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderViewAllLink = () => {
    if (!viewMoreUrl)
      return null;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(viewMoreUrl, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({
      commonStyle: __spreadValues({ backgroundSize: "cover" }, restStyle)
    }, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: `${title}HorizontalBlock`
    })), {
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsxs(Header, {
          device,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(Label, {
              commonStyle: titleStyle,
              children: title
            }),
            renderViewAllLink()
          ]
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductListWrapper, {
          children: collectionSlug || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
            `left_banner_product_${device}`,
            mappingDynamicSlots,
            ssrData,
            {
              collectionSlug,
              showTwoProductRows,
              topBanner,
              bottomBanner
            }
          ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
        })
      ]
    }))
  }));
};
LeftBannerProduct.displayName = "Omni_LeftBannerProduct";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${getStyles.getStyle(commonStyle)}
`
);
const Header = styled__default["default"](BlockHeader.BlockHeader)(
  `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  color: #ffffff;
`
);
const Label = styled__default["default"].div(
  ({ commonStyle }) => `
    flex: 1;
    margin-right: 8px;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;

    ${getStyles.getStyle(commonStyle)}
  `
);
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
    display: flex;
    align-items: center;
    ${getStyles.getStyle(commonStyle)}
  `
);
const ProductListWrapper = styled__default["default"].div`
  padding: 1rem;
`;

exports.LeftBannerProduct = LeftBannerProduct;


/***/ }),

/***/ 646446:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var React = __webpack_require__(891987);
var Container = __webpack_require__(739890);
var BlockHeader = __webpack_require__(177530);
var renderDynamicSlot = __webpack_require__(744175);
var EmptyProduct = __webpack_require__(867118);
var grid = __webpack_require__(793767);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListingTab = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    ssrData,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "ssrData",
    "maxWidth"
  ]);
  var _c, _d;
  const [activeTab, setActiveTab] = React.useState(0);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    items = [],
    commonStyle,
    title,
    activeTabStyle
  } = _a2, rest = __objRest(_a2, [
    "items",
    "commonStyle",
    "title",
    "activeTabStyle"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const tabHeadRef = React.useRef();
  const tabHead = tabHeadRef == null ? void 0 : tabHeadRef.current;
  const isDesktop = device === "desktop";
  React.useEffect(() => {
    if (tabHead && tabHead.scroll) {
      const activeDom = tabHead.childNodes[activeTab];
      tabHead.scroll({
        left: activeDom.offsetLeft - (tabHead.offsetWidth - activeDom.offsetWidth) / 2,
        behavior: "smooth"
      });
    }
  }, [activeTab, tabHead]);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    maxWidth,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
          device,
          children: /* @__PURE__ */ jsxRuntime.jsx(Title, {
            children: title
          })
        }),
        !!(items == null ? void 0 : items.length) && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
              ref: tabHeadRef,
              children: items.map(({ src, title: title2 }, index) => /* @__PURE__ */ jsxRuntime.jsxs(TabItem, __spreadProps(__spreadValues({
                className: activeTab === index ? "active" : "",
                onClick: () => setActiveTab(index)
              }, !isEditingMode && coreRenderer.getTrackingData({
                isTrackContent: true,
                regionName: "forYouTabCategory",
                contentName: title2,
                index
              })), {
                isDesktop,
                hasImage: !!src,
                activeTabStyle,
                children: [
                  !!src && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
                    src,
                    alt: title2 || "Image",
                    commonStyle: {
                      objectFit: "cover",
                      position: "relative",
                      display: "inline-block",
                      margin: {
                        bottom: 4
                      },
                      height: 44,
                      width: 44
                    }
                  }),
                  /* @__PURE__ */ jsxRuntime.jsx(TabTitle, {
                    isDesktop,
                    children: title2
                  })
                ]
              }), index))
            }),
            /* @__PURE__ */ jsxRuntime.jsx("div", {
              children: ((_c = items == null ? void 0 : items[activeTab]) == null ? void 0 : _c.collectionSlug) || isEditingMode ? renderDynamicSlot.renderDynamicSlot(
                `product_grid_${device}`,
                mappingDynamicSlots,
                activeTab === 0 ? ssrData : void 0,
                {
                  collectionSlug: (_d = items == null ? void 0 : items[activeTab]) == null ? void 0 : _d.collectionSlug,
                  config: { regionName: "productCard" }
                }
              ) : /* @__PURE__ */ jsxRuntime.jsx(EmptyProduct.EmptyProduct, {})
            })
          ]
        })
      ]
    })
  }));
};
ListingTab.displayName = "Omni_ListingTab";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  border-radius: 8px;
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
  `
);
const Title = styled__default["default"].div`
  color: rgb(51, 51, 51);
  font-weight: 700;
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.5;
  background-color: #ffffff;
`;
const HeaderWrapper = styled__default["default"].div`
  overflow-x: scroll;
  position: sticky;
  width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  scroll-snap-type: x mandatory;
  display: flex;
  align-items: stretch;
  background-color: #ffffff;
`;
const TabItem = styled__default["default"].div(
  ({ isDesktop, hasImage, activeTabStyle }) => `
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  flex-direction: column;
  position: relative;
  background: rgb(255, 255, 255);
  display: inline-flex;
  scroll-snap-align: start;
  justify-content: ${hasImage ? `flex-start` : `center`};
  height: auto;
  ${isDesktop ? `min-width: 120px; width: 120px; padding: 12px 0;` : `min-width: 90px; width: 90px; padding: 8px 0;`}
  &.active {
    color: rgb(51, 51, 51);
    ${coreRenderer.getStyle(activeTabStyle)}
  }
  &:hover {
    cursor: pointer;
  }
`
);
const TabTitle = styled__default["default"].span(
  ({ isDesktop }) => `
  color: rgb(51, 51, 51);
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  text-align: center;
  
  ${isDesktop ? `font-size: 14px; padding: 0 12px;` : `font-size: 12px; padding: 0 8px;`}
`
);

exports.ListingTab = ListingTab;


/***/ }),

/***/ 537964:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var clsx = __webpack_require__(981892);
var MegaMenuContent = __webpack_require__(793197);
var coreRenderer = __webpack_require__(327723);
var menu = __webpack_require__(712797);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenu = ({ menu: menu$1 = [], primaryColor, isEditingMode }) => {
  const { globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const [activeMenu, setActiveMenu] = React.useState();
  const MAX_LENGTH_MENU = 14;
  const tree = menu.flattenToTree((menu$1 || []).filter((el) => !el.isHidden)).slice(
    0,
    MAX_LENGTH_MENU
  );
  return /* @__PURE__ */ jsxRuntime.jsxs("div", {
    onMouseLeave: () => setActiveMenu(null),
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
        className: clsx__default["default"]((activeMenu == null ? void 0 : activeMenu.children.length) > 0 ? ["active"] : null),
        children: tree == null ? void 0 : tree.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && !isPreviewMode && coreRenderer.getTrackingData({
          isTrackContent: true,
          contentName: item == null ? void 0 : item.name,
          regionName: "megaMenuText"
        })), {
          children: /* @__PURE__ */ jsxRuntime.jsxs(MenuItemWrapper, {
            href: menu.getUrlOfMenuItem(item, isEditingMode),
            primaryColor,
            onMouseEnter: () => {
              setActiveMenu(item);
            },
            children: [
              (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(IconImg, {
                src: item == null ? void 0 : item.iconUrl,
                alt: item == null ? void 0 : item.name
              }),
              /* @__PURE__ */ jsxRuntime.jsx(Caption, {
                children: item == null ? void 0 : item.name
              })
            ]
          }, index)
        })))
      }),
      /* @__PURE__ */ jsxRuntime.jsx(VerticalMenuPanel, {
        className: clsx__default["default"]((activeMenu == null ? void 0 : activeMenu.children.length) > 0 ? ["active"] : null),
        children: activeMenu && /* @__PURE__ */ jsxRuntime.jsx(MegaMenuContent.MegaMenuContent, {
          menu: activeMenu,
          primaryColor,
          isEditingMode,
          type: "vertical"
        })
      })
    ]
  });
};
const verticalMenuWidth = "12.375rem";
const megaMenuHeight = "28.5rem";
const Wrapper = styled__default["default"].div`
  border-radius: 0.5rem;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
  z-index: 980;
  height: ${megaMenuHeight};
  width: ${verticalMenuWidth};

  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
const MenuItemWrapper = styled__default["default"].a(
  ({ primaryColor = "#1435c3" }) => `
  cursor: pointer;
  color: black;
  text-decoration: none;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
  padding: 0 0.5rem;
  border-radius: 0.5rem;
  overflow: hidden;

  &:hover {
    background-color: #ababab20;
    color: ${primaryColor} !important;
  }
`
);
const Caption = styled__default["default"].div`
  flex: 1 1 0%;
  margin: 0px;
  padding: 0px;
  border-style: none;
  border-width: 1px;
  border-color: unset;
  opacity: 1;
  color: inherit;
  font-weight: 500;
  text-decoration: unset;
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  max-width: unset;
  min-width: unset;
  transition: color 0.3s ease 0s;
`;
const VerticalMenuPanel = styled__default["default"].div`
  position: absolute;
  top: 0;
  width: calc(75rem - 12.375rem);
  left: 12.375rem;
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.1s;
  visibility: hidden;
  opacity: 0;
  border-radius: 0.5rem;
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`;
const IconImg = styled__default["default"].img`
  width: 22px;
  height: 22px;
`;

exports.MegaMenu = MegaMenu;


/***/ }),

/***/ 793197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var utils = __webpack_require__(536324);
var coreRenderer = __webpack_require__(327723);
var menu = __webpack_require__(712797);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenuContent = ({
  menu: menu$1,
  primaryColor = "#434657",
  isEditingMode = false,
  type = "vertical"
}) => {
  const getMenuColumns = () => {
    let totalCols = 6;
    if (type === "vertical")
      totalCols--;
    return totalCols;
  };
  const { globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const newMenu = utils.convertMegaMenu(menu$1, getMenuColumns());
  return /* @__PURE__ */ jsxRuntime.jsx(StyledContentPanel, {
    children: newMenu == null ? void 0 : newMenu.map((col) => /* @__PURE__ */ jsxRuntime.jsx(MegaMenuColumn, {
      children: col.items.map((item, index) => {
        var _a;
        return /* @__PURE__ */ jsxRuntime.jsxs(MegaMenuSubColumn, {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
            marginBottom: "1.5rem"
          },
          children: [
            /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && !isPreviewMode && coreRenderer.getTrackingData({
              isTrackContent: true,
              contentName: `${menu$1.name} > ${item.name}`,
              regionName: "megaMenuText"
            })), {
              children: /* @__PURE__ */ jsxRuntime.jsx(StyledLink, {
                href: menu.getUrlOfMenuItem(item, isEditingMode),
                primaryColor,
                children: item == null ? void 0 : item.name
              })
            })),
            (_a = item == null ? void 0 : item.children) == null ? void 0 : _a.map((child) => /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
              children: (child == null ? void 0 : child.name) && /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && !isPreviewMode && coreRenderer.getTrackingData({
                isTrackContent: true,
                contentName: `${menu$1.name} > ${item.name} > ${child.name}`,
                regionName: "megaMenuText"
              })), {
                children: /* @__PURE__ */ jsxRuntime.jsx(StyledChildLink, {
                  href: menu.getUrlOfMenuItem(child, isEditingMode),
                  primaryColor,
                  children: child.name
                })
              }))
            }))
          ]
        }, index);
      })
    }))
  });
};
const StyledContentPanel = styled__default["default"].div`
  background-color: #ffffff;
  display: flex;
  flex: 1 1 0%;
  min-height: 28.5rem;
  padding: 0.75rem;
`;
const StyledLink = styled__default["default"].a(
  ({ primaryColor }) => `
color: ${primaryColor};
text-decoration: none;
font-size: 14px;
font-weight: bold;

&:hover {
  color: ${primaryColor};
}
`
);
const StyledChildLink = styled__default["default"].a(
  ({ primaryColor }) => `
  color: rgb(67, 70, 87);
  text-decoration: none;
  font-size: 14px;

  &:hover {
    color: ${primaryColor ? primaryColor : `rgb(20, 53, 195)`};
  }
`
);
const MegaMenuColumn = styled__default["default"].div`
  width: 25%;
  padding: 0px 8px;
  font-size: 20;
`;
const MegaMenuSubColumn = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

exports.MegaMenuContent = MegaMenuContent;


/***/ }),

/***/ 536324:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const convertMegaMenu = (menu, numberCol) => {
  if (numberCol < 1)
    return [];
  const newArr = menu.children.map((m) => {
    return {
      len: m.children.length + 1,
      items: [__spreadValues({}, m)]
    };
  });
  if (newArr.length <= numberCol)
    return newArr;
  newArr.sort((a, b) => b.len - a.len);
  const result = [...newArr.slice(0, numberCol)];
  let min;
  let k;
  for (let i = numberCol; i < newArr.length; i++) {
    min = result[0].len;
    k = 0;
    for (let j = 0; j < numberCol; j++) {
      if (min > result[j].len) {
        min = result[j].len;
        k = j;
      }
    }
    result[k] = {
      len: result[k].len + newArr[i].len,
      items: [...result[k].items, ...newArr[i].items]
    };
  }
  return result;
};

exports.convertMegaMenu = convertMegaMenu;


/***/ }),

/***/ 667679:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var coreRenderer = __webpack_require__(327723);
var MixBannerSide = __webpack_require__(513739);
var Container = __webpack_require__(739890);
var grid = __webpack_require__(793767);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MixBanner = (_a) => {
  var _b = _a, {
    isEditingMode,
    maxWidth
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "maxWidth"
  ]);
  const { device } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), { left, right, commonStyle, titleStyle, viewMoreStyle } = _a2, rest = __objRest(_a2, ["left", "right", "commonStyle", "titleStyle", "viewMoreStyle"]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  return /* @__PURE__ */ jsxRuntime.jsxs(Container.Container, __spreadProps(__spreadValues({
    commonStyle: {
      maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH,
      padding,
      margin,
      display: "flex",
      gap: 16
    }
  }, rest), {
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(MixBannerSide.MixBannerSide, __spreadProps(__spreadValues({}, left), {
        commonStyle: __spreadValues(__spreadValues({}, restStyle), left == null ? void 0 : left.commonStyle),
        isEditingMode,
        titleStyle,
        viewMoreStyle
      })),
      /* @__PURE__ */ jsxRuntime.jsx(MixBannerSide.MixBannerSide, __spreadProps(__spreadValues({}, right), {
        commonStyle: __spreadValues(__spreadValues({}, restStyle), right == null ? void 0 : right.commonStyle),
        isEditingMode,
        titleStyle,
        viewMoreStyle
      }))
    ]
  }));
};
MixBanner.displayName = "Omni_MixBanner";

exports.MixBanner = MixBanner;


/***/ }),

/***/ 513739:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(225956);
var coreRenderer = __webpack_require__(327723);
var Row = __webpack_require__(607933);
var Col = __webpack_require__(483879);
var renderLink = __webpack_require__(62534);
var BlockHeader = __webpack_require__(177530);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const { cardDefaultImage: defaultImage } = coreRenderer.mappingAssets;
const MixBannerSide = ({
  isEditingMode,
  title,
  redirectUrl,
  mainBanner,
  rightBanners,
  bottomBanners,
  commonStyle,
  titleStyle,
  viewMoreStyle
}) => {
  var _a, _b, _c;
  const { device } = coreRenderer.useStore();
  const { displayItems: displayRightBanners } = coreRenderer.useTimeVisibility(
    rightBanners,
    isEditingMode
  );
  const { displayItems: displayBottomBanners } = coreRenderer.useTimeVisibility(
    bottomBanners,
    isEditingMode
  );
  const renderViewAllLink = () => {
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewMore, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(redirectUrl, content, isEditingMode);
  };
  const renderMainBanner = () => {
    if (!mainBanner)
      return null;
    const { googleImageParams, src, alt, event } = mainBanner;
    const content = /* @__PURE__ */ jsxRuntime.jsx(StyleMainBanner, __spreadValues({
      googleImageParams: googleImageParams || {
        width: 400
      },
      src: src || defaultImage,
      alt: alt || "Image",
      commonStyle: {
        hover: { zoom: 105 },
        objectFit: "cover",
        width: "100%",
        height: "100%"
      }
    }, !isEditingMode && coreRenderer.getTrackingData({
      isTrackContent: true,
      regionName: "categoriesBlockBrand",
      contentName: title,
      target: coreRenderer.getTargetOfTrackingFromEvent(event)
    })));
    return /* @__PURE__ */ jsxRuntime.jsx(ImageWrapper, {
      children: renderLink.renderLink(event, content, isEditingMode)
    });
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    commonStyle,
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Header, {
        device,
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Label, {
            commonStyle: titleStyle,
            children: title
          }),
          !!redirectUrl && renderViewAllLink()
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(Row.Row, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Col.Col, {
            span: 4,
            children: renderMainBanner()
          }),
          /* @__PURE__ */ jsxRuntime.jsx(Col.Col, {
            span: 8,
            children: /* @__PURE__ */ jsxRuntime.jsx(ContentItemsWrapper, {
              children: (_c = (_a = displayRightBanners == null ? void 0 : displayRightBanners.slice) == null ? void 0 : (_b = _a.call(displayRightBanners, 0, 4)).map) == null ? void 0 : _c.call(_b, (banner, index) => {
                const content = /* @__PURE__ */ jsxRuntime.jsxs(ContentItem, {
                  children: [
                    /* @__PURE__ */ jsxRuntime.jsx(StyledRightTitle, {
                      children: banner == null ? void 0 : banner.alt
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
                      googleImageParams: banner.googleImageParams || { width: 300 },
                      src: banner.src || defaultImage,
                      alt: banner.alt || banner.title || "Image",
                      commonStyle: {
                        hover: { zoom: 105 },
                        objectFit: "contain",
                        height: 120
                      }
                    })
                  ]
                });
                return renderLink.renderLink(banner == null ? void 0 : banner.event, content, isEditingMode, index);
              })
            })
          })
        ]
      }),
      !!(displayBottomBanners == null ? void 0 : displayBottomBanners.length) && /* @__PURE__ */ jsxRuntime.jsx(Footer, {
        children: displayBottomBanners.map((banner, index) => {
          const content = /* @__PURE__ */ jsxRuntime.jsx(StyledBottomImage, __spreadValues({
            googleImageParams: banner.googleImageParams || { width: 200 },
            src: banner.src || defaultImage,
            alt: banner.alt || "Image",
            commonStyle: {
              hover: { zoom: 105 },
              objectFit: "contain",
              height: 68
            }
          }, !isEditingMode && coreRenderer.getTrackingData({
            isTrackContent: true,
            regionName: "categoriesBlockBrand",
            contentName: "bottomCategoriesBlockBrand",
            index,
            target: coreRenderer.getTargetOfTrackingFromEvent(banner.event)
          })));
          return renderLink.renderLink(banner.event, content, isEditingMode, index);
        })
      })
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  overflow: hidden;
  flex: 50%;
  ${coreRenderer.getStyle(commonStyle)}
  `
);
const Header = styled__default["default"](BlockHeader.BlockHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Label = styled__default["default"].div(
  ({ commonStyle }) => `
  flex: 1;
  margin-right: 8px;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const ImageWrapper = styled__default["default"].div`
  height: 356px;
  div {
    height: 100%;
  }
`;
const StyleMainBanner = styled__default["default"](coreRenderer.ImageBase)`
  display: inline-block;
  overflow: hidden;
  height: 100%;
  width: 100%;
  transition: transform 0.3s ease 0s;
`;
const ContentItemsWrapper = styled__default["default"].div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0;

  & > :nth-child(odd) {
    border-right: 1px solid rgb(224, 224, 224);
  }
  & > :nth-child(-n + 2) {
    border-bottom: 1px solid rgb(224, 224, 224);
  }
`;
const ContentItem = styled__default["default"].div`
  text-align: center;
  padding: 1rem;
  height: 100%;
`;
const StyledRightTitle = styled__default["default"].div`
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
const Footer = styled__default["default"].div`
  display: flex;
  justify-content: space-between;

  & > * {
    flex: 1;
  }
`;
const StyledBottomImage = styled__default["default"](coreRenderer.ImageBase)`
  width: 100%;
`;
const ViewMore = styled__default["default"].span(
  ({ commonStyle }) => `
    display: flex;
    align-items: center;
    ${coreRenderer.getStyle(commonStyle)}
  `
);

exports.MixBannerSide = MixBannerSide;


/***/ }),

/***/ 504552:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var Container = __webpack_require__(739890);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniFooter = (_a) => {
  var _b = _a, {
    children,
    commonStyle
  } = _b, other = __objRest(_b, [
    "children",
    "commonStyle"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    fluid: true,
    commonStyle
  }, other), {
    children
  }));
};
OmniFooter.displayName = "Omni_Footer";

exports.OmniFooter = OmniFooter;


/***/ }),

/***/ 950675:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const DEFAULT_CATEGORY_BLOCK_RADIUS = 4;
const DEFAULT_MAX_WIDTH = 1232;
const DEFAULT_ECOMMERCE_HEADER_PROPS = {
  syncDeviceStyle: true,
  categoryBlockRadius: DEFAULT_CATEGORY_BLOCK_RADIUS,
  desktop: {
    primaryColor: "#7367F0"
  },
  mobile: {
    primaryColor: "#7367F0"
  },
  layout: "horizontal",
  maxWidth: DEFAULT_MAX_WIDTH,
  logoDesktop: {
    src: "https://lh3.googleusercontent.com/bhg6FoxZPA5S6q50_Gmu6YgMt2GcKxpjsbnaRvvHUwSV9JSnAj83TpbJEHIJjgKnbNoZmM7Mnx0pBlUau5CG2yIOG5v7rGc",
    commonStyle: {
      width: 128
    },
    alt: "logo"
  },
  logoMobile: {
    src: "https://lh3.googleusercontent.com/QQLcWuF3LeVbgQdHjwDNnEUWoobbmTHRBuDIMoaYiADyIDZymjn1IbtEisUXCcgAycD0yNhuQ4aRF1WAaKSL9HHUr7bvfwA",
    commonStyle: {
      width: 128,
      marginRight: 16
    },
    alt: "logo"
  },
  topBanner: {
    src: "https://lh3.googleusercontent.com/TpMhcfQsg7n_tCOYvj8mssYVWIg-TWaVhMOT_Lua0YvyIqOVBVCaQ1tboj_IyTf_KfLrgA2mhUloN9T2ekgyHP0ZQrYCRYg=rw-w1920",
    alt: "topBanner",
    commonStyle: {
      height: 56
    }
  },
  topBarMenu: [
    {
      title: "Khuy\u1EBFn m\u1EA1i",
      icon: {
        src: "https://lh3.googleusercontent.com/Bs986m6Kux0Lc47JKef2wzI2B2-kWgqt-7Vc3fAbCPAQ6q-5qXt4advONbDMlLqTR02KmHVeE8DwHYpQ7rkTHzv-X10hTj99=rw-w512"
      }
    },
    {
      title: "H\u1EC7 th\u1ED1ng Showroom",
      icon: {
        src: "https://lh3.googleusercontent.com/KJweUKGVn27k3y-SzqPOoxnxND8eyApxXJSEtev3dUljWKm3kyAxgXwzeFqsVvY5TFXSOD4vmoPwTPt2lKAJScsLX0_jXqxX6g=rw-w512"
      }
    },
    {
      title: "T\u01B0 v\u1EA5n mua h\xE0ng",
      icon: {
        src: "https://lh3.googleusercontent.com/IbF2IPMW_0QRtyuE2Qwqzu3rjSVrbRUQnQGSFXGBOkwqAwB-768TIybtM88idvlHFb4DHT-ybEhdnAX2PS_5rlKvCfCu_tJq=rw-w512"
      }
    },
    {
      title: "Tin c\xF4ng ngh\u1EC7",
      icon: {
        src: "https://lh3.googleusercontent.com/OYvO0n57IbvxtIDCkjM75Yz2r0rvfC9fD5f5YGhrGOBpjwEtN0DKdeQDijSEN95tOdU7-dr9G72kjpn_D8Vuelp-5Ev8C3jA=rw-w512"
      }
    },
    {
      title: "X\xE2y d\u1EF1ng c\u1EA5u h\xECnh",
      icon: {
        src: "https://lh3.googleusercontent.com/IHjqUa3vlKyhiixaFB4HnFBP1shDS8h2O1_qo6ylgcW5UFaymUF3imy9YTsBZn7l7Zi1u6sKe8ZcJSKLc994rEye_mEAD969=rw-w512"
      }
    }
  ]
};
const DEFAULT_TOP_BAR_MENU_ITEM = {
  title: "Lorem Ipsum"
};

exports.DEFAULT_CATEGORY_BLOCK_RADIUS = DEFAULT_CATEGORY_BLOCK_RADIUS;
exports.DEFAULT_ECOMMERCE_HEADER_PROPS = DEFAULT_ECOMMERCE_HEADER_PROPS;
exports.DEFAULT_MAX_WIDTH = DEFAULT_MAX_WIDTH;
exports.DEFAULT_TOP_BAR_MENU_ITEM = DEFAULT_TOP_BAR_MENU_ITEM;


/***/ }),

/***/ 430272:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(891987);

const OmniHeaderContext = React.createContext({});
const OmniHeaderProvider = OmniHeaderContext.Provider;
const useOmniHeader = () => React.useContext(OmniHeaderContext);

exports.OmniHeaderContext = OmniHeaderContext;
exports.OmniHeaderProvider = OmniHeaderProvider;
exports.useOmniHeader = useOmniHeader;


/***/ }),

/***/ 91562:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var HorizontalCategories = __webpack_require__(361606);
var VerticalCategories = __webpack_require__(992014);
var coreRenderer = __webpack_require__(327723);
var context = __webpack_require__(430272);
var constants = __webpack_require__(950675);
var Row = __webpack_require__(607933);
var Col = __webpack_require__(483879);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MainNavigationBar = ({
  logo,
  searchSlot,
  rightItemsSlot,
  layout,
  showMenu,
  setShowMenu,
  primaryColor,
  border,
  maxWidth = constants.DEFAULT_MAX_WIDTH
}) => {
  const isVertical = layout === "vertical";
  const isHorizontal = layout === "horizontal";
  const { globalData } = coreRenderer.useStore();
  const { isEditingMode = false } = context.useOmniHeader();
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Content, {
        maxWidth,
        children: /* @__PURE__ */ jsxRuntime.jsxs(StyledRow, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(StyledCol, {
              children: /* @__PURE__ */ jsxRuntime.jsxs(LogoWrapper, {
                children: [
                  (globalData == null ? void 0 : globalData.isHomepage) ? /* @__PURE__ */ jsxRuntime.jsx("h1", {
                    children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, logo), {
                      event: {
                        eventType: "link",
                        link: { href: isEditingMode ? null : "/" }
                      }
                    }))
                  }) : /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, logo), {
                    event: {
                      eventType: "link",
                      link: { href: isEditingMode ? null : "/" }
                    }
                  })),
                  isVertical && /* @__PURE__ */ jsxRuntime.jsx(VerticalCategories.VerticalCategories, {
                    showMenu,
                    setShowMenu,
                    primaryColor,
                    border
                  })
                ]
              })
            }),
            /* @__PURE__ */ jsxRuntime.jsx(StyledCol, {
              style: {
                flex: "1 1 auto"
              },
              children: searchSlot
            }),
            /* @__PURE__ */ jsxRuntime.jsx(StyledCol, {
              children: rightItemsSlot
            })
          ]
        })
      }),
      isHorizontal && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Divider, {}),
          /* @__PURE__ */ jsxRuntime.jsx(Content, {
            maxWidth,
            children: /* @__PURE__ */ jsxRuntime.jsx(Row.Row, {
              children: /* @__PURE__ */ jsxRuntime.jsx(Col.Col, {
                span: 12,
                children: /* @__PURE__ */ jsxRuntime.jsx(HorizontalCategories.HorizontalCategories, {
                  primaryColor
                })
              })
            })
          })
        ]
      })
    ]
  });
};
const Wrapper = styled__default["default"].nav`
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
`;
const Content = styled__default["default"].div(
  ({ maxWidth = constants.DEFAULT_MAX_WIDTH }) => `
   max-width: ${maxWidth}px;
  margin: 0 auto;
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
`
);
const StyledRow = styled__default["default"](Row.Row)`
  margin-left: -8px;
  margin-right: -8px;
  row-gap: 16px;
  min-height: 88px;
  align-items: center;

  @media (min-width: 1024px) {
    justify-content: center;
  }
`;
const StyledCol = styled__default["default"](Col.Col)`
  padding-left: 8px;
  padding-right: 8px;
`;
const Divider = styled__default["default"].div`
  display: flex;
  width: 100%;
  border-top: 1px solid #e4e5f0;
`;
const LogoWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

exports.MainNavigationBar = MainNavigationBar;


/***/ }),

/***/ 920659:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var TopBarMenu = __webpack_require__(475756);
var MainNavigationBar = __webpack_require__(91562);
var TopBanner = __webpack_require__(478535);
var context = __webpack_require__(430272);
var renderDynamicSlot = __webpack_require__(744175);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniDesktopHeader = (_a) => {
  var _b = _a, {
    ssrData
  } = _b, rest = __objRest(_b, [
    "ssrData"
  ]);
  const { isEditingMode = false } = context.useOmniHeader();
  const {
    topBarMenu = [],
    logoDesktop,
    topBanner,
    layout,
    maxWidth,
    categoryBlockRadius
  } = rest || {};
  const _a2 = coreRenderer.getPropsByDevice(
    rest,
    "desktop"
  ), { primaryColor, commonStyle } = _a2, others = __objRest(_a2, ["primaryColor", "commonStyle"]);
  const { mappingDynamicSlots, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const [showMenu, setShowMenu] = React__default["default"].useState(false);
  const searchSlot = renderDynamicSlot.renderDynamicSlot(
    `header_search_desktop`,
    mappingDynamicSlots,
    ssrData,
    {
      primaryColor
    }
  );
  const rightItemsSlot = renderDynamicSlot.renderDynamicSlot(
    `header_right_items_desktop`,
    mappingDynamicSlots,
    ssrData
  );
  const isShowTopBanner = isEditingMode || coreRenderer.validateIsVisibleComponent((topBanner == null ? void 0 : topBanner.timeVisibility) || {});
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      showMenu && /* @__PURE__ */ jsxRuntime.jsx(Backdrop, {
        onClick: () => setShowMenu(false)
      }),
      isShowTopBanner && /* @__PURE__ */ jsxRuntime.jsxs("div", __spreadProps(__spreadValues({}, !isEditingMode && !isPreviewMode && coreRenderer.getTrackingData({ isTrackContent: true, regionName: "topBanner" })), {
        children: [
          " ",
          /* @__PURE__ */ jsxRuntime.jsx(TopBanner.TopBanner, __spreadValues(__spreadValues({}, topBanner), others))
        ]
      })),
      /* @__PURE__ */ jsxRuntime.jsx(TopBarMenu.TopBarMenu, __spreadValues({
        items: topBarMenu,
        backgroundColor: primaryColor,
        isEditingMode
      }, others)),
      /* @__PURE__ */ jsxRuntime.jsx(Header, __spreadProps(__spreadValues({
        commonStyle,
        isEditingMode
      }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(MainNavigationBar.MainNavigationBar, {
          logo: logoDesktop,
          layout,
          searchSlot,
          rightItemsSlot,
          showMenu,
          setShowMenu,
          primaryColor,
          border: categoryBlockRadius,
          maxWidth
        })
      }))
    ]
  });
};
const Header = styled__default["default"].header(
  ({ commonStyle, isEditingMode }) => `
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: ${isEditingMode ? "550" : "1040"};
    margin-bottom: 24px;
    ${coreRenderer.getStyle(commonStyle)}
    `
);
const Backdrop = styled__default["default"].div`
  position: fixed;
  inset: 0px;
  background: rgba(0, 0, 0, 0.5);
  transition-delay: 0.1s;
  z-index: 550;
`;

exports.OmniDesktopHeader = OmniDesktopHeader;


/***/ }),

/***/ 478535:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TopBanner = (_a) => {
  var _b = _a, {
    timeVisibility,
    commonStyle
  } = _b, props = __objRest(_b, [
    "timeVisibility",
    "commonStyle"
  ]);
  if (!props.src)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, props), {
      commonStyle: __spreadProps(__spreadValues({}, commonStyle), { display: "block" })
    }))
  });
};
const Wrapper = styled__default["default"].div`
  position: relative;
  z-index: 550;
`;

exports.TopBanner = TopBanner;


/***/ }),

/***/ 475756:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var Link = __webpack_require__(688701);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TopBarMenu = (_a) => {
  var _b = _a, { items, backgroundColor, isEditingMode } = _b, rest = __objRest(_b, ["items", "backgroundColor", "isEditingMode"]);
  const { globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  if (!(items == null ? void 0 : items.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
    backgroundColor
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsx(ContentWrapper, {
      maxWidth: rest.maxWidth,
      children: /* @__PURE__ */ jsxRuntime.jsx(Content, {
        children: items == null ? void 0 : items.map(({ event, icon, title }, index) => {
          var _a2;
          return /* @__PURE__ */ jsxRuntime.jsx("div", __spreadProps(__spreadValues({}, !isEditingMode && !isPreviewMode && coreRenderer.getTrackingData({
            isTrackContent: true,
            contentName: title,
            regionName: "topBarMenu",
            target: (_a2 = event == null ? void 0 : event.link) == null ? void 0 : _a2.href
          })), {
            children: /* @__PURE__ */ React.createElement(Link.Link, __spreadProps(__spreadValues({}, event), {
              key: index
            }), /* @__PURE__ */ jsxRuntime.jsxs(MenuItem, {
              children: [
                (icon == null ? void 0 : icon.src) && /* @__PURE__ */ jsxRuntime.jsx("img", {
                  src: icon.src,
                  style: {
                    width: 18,
                    height: 18
                  },
                  alt: title
                }),
                title
              ]
            }))
          }), index);
        })
      })
    })
  }));
};
const Wrapper = styled__default["default"].nav(
  ({ backgroundColor }) => `
  position: relative;
  min-height: 42px;
  ${backgroundColor && `background-color: ${backgroundColor};`}
  z-index: 550;
`
);
const ContentWrapper = styled__default["default"].div(
  ({ maxWidth }) => `
  max-width: ${maxWidth || "1232"}px;
  margin: 0 auto;
  text-align: right;
`
);
const Content = styled__default["default"].div`
  display: inline-flex;
  color: white;
  white-space: pre;
  max-width: 100%;
  overflow: hidden;
`;
const MenuItem = styled__default["default"].div`
  display: flex;
  align-items: center;
  padding: 0 1.25rem;
  cursor: pointer;
  height: 42px;
  gap: 0.5rem;
`;

exports.TopBarMenu = TopBarMenu;


/***/ }),

/***/ 361606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var React = __webpack_require__(891987);
var clsx = __webpack_require__(981892);
var context = __webpack_require__(430272);
var MegaMenuContent = __webpack_require__(793197);
var menu = __webpack_require__(712797);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const HorizontalCategories = ({ primaryColor }) => {
  const { isEditingMode = false, menu: menu$1 = [] } = context.useOmniHeader();
  const [activeMenu, setActiveMenu] = React.useState();
  if (!(menu$1 == null ? void 0 : menu$1.length))
    return null;
  const tree = menu.flattenToTree(menu$1.filter((el) => !el.isHidden));
  return /* @__PURE__ */ jsxRuntime.jsxs("div", {
    onMouseLeave: () => setActiveMenu(null),
    style: { position: "relative" },
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
        children: tree == null ? void 0 : tree.map((item, index) => /* @__PURE__ */ jsxRuntime.jsxs(CategoryItem, {
          href: menu.getUrlOfMenuItem(item, isEditingMode),
          primaryColor,
          onMouseEnter: () => {
            setActiveMenu(item);
          },
          children: [
            (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx(StyledImage, {
              src: item == null ? void 0 : item.iconUrl,
              alt: item == null ? void 0 : item.name
            }),
            item == null ? void 0 : item.name
          ]
        }, index))
      }),
      activeMenu && /* @__PURE__ */ jsxRuntime.jsx(HorizontalMenuPanel, {
        className: clsx__default["default"]((activeMenu == null ? void 0 : activeMenu.children.length) > 0 ? ["active"] : null),
        children: /* @__PURE__ */ jsxRuntime.jsx(MegaMenuContent.MegaMenuContent, {
          menu: activeMenu,
          primaryColor,
          isEditingMode,
          type: "horizontal"
        })
      })
    ]
  });
};
const Wrapper = styled__default["default"].div`
  position: relative;
  height: 3rem;
  background-color: #ffffff;
  width: 100%;
  overflow: hidden;
`;
const HorizontalMenuPanel = styled__default["default"].div`
  background-color: rgb(255, 255, 255);
  display: flex;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 3rem;
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s ease 0s;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;

  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(rgba(0, 0, 0, 0.05) 0px 2px 4px);
  }
`;
const CategoryItem = styled__default["default"].a(
  ({ primaryColor }) => `
  cursor: pointer;
  padding: 0 0.75rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: #434657;
  font-weight: 500;
  text-decoration: unset;
  font-size: 13px;
  line-height: 20px;
  
  &:hover {
    color: ${primaryColor};
  }

  &:hover::after {
    opacity: 1;
  }

  &::after {
    content: '';
    height: 2px;
    background-color: ${primaryColor};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}
`
);
const StyledImage = styled__default["default"].img`
  width: 22px;
  height: 22px;
  margin-right: 0.5rem;
`;

exports.HorizontalCategories = HorizontalCategories;


/***/ }),

/***/ 992014:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var ListIcon = __webpack_require__(994193);
var context = __webpack_require__(430272);
var constants = __webpack_require__(950675);
var MegaMenu = __webpack_require__(537964);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const VerticalCategories = ({ showMenu = false, setShowMenu, primaryColor, border }) => {
  const { isEditingMode = false, menu = [] } = context.useOmniHeader();
  if (!(menu == null ? void 0 : menu.length))
    return null;
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
        border,
        onClick: () => setShowMenu(!showMenu),
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(ListIcon.ListIcon, {}),
          /* @__PURE__ */ jsxRuntime.jsx("span", {
            style: { marginLeft: "0.5rem" },
            children: "Danh m\u1EE5c s\u1EA3n ph\u1EA9m"
          })
        ]
      }),
      showMenu && /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: /* @__PURE__ */ jsxRuntime.jsx(MenuWrapper, {
          children: /* @__PURE__ */ jsxRuntime.jsx(MegaMenu.MegaMenu, {
            menu,
            primaryColor,
            isEditingMode
          })
        })
      })
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({ border = constants.DEFAULT_CATEGORY_BLOCK_RADIUS }) => `
  border: 1px solid rgb(224, 224, 224);
  cursor: pointer;
  border-radius: ${border}px;
  line-height: 1rem;
  padding: 0.4rem 0.75rem;
  text-align: center;
  color: rgb(130, 134, 158);
  margin: 0 0.5rem;
  user-select: none;
`
);
const MenuWrapper = styled__default["default"].div`
  position: absolute;
  inset: 0px auto auto 0px;
  visibility: visible;
  z-index: 999;
  transform: translate(16px, 72px) !important;
`;

exports.VerticalCategories = VerticalCategories;


/***/ }),

/***/ 174121:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);

const CloseIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "m4.21 4.387.083-.094a1 1 0 0 1 1.32-.083l.094.083L12 10.585l6.293-6.292a1 1 0 1 1 1.414 1.414L13.415 12l6.292 6.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083L12 13.415l-6.293 6.292a1 1 0 0 1-1.414-1.414L10.585 12 4.293 5.707a1 1 0 0 1-.083-1.32l.083-.094-.083.094Z",
      fill: "currentColor"
    })
  });
};

exports.CloseIcon = CloseIcon;


/***/ }),

/***/ 998439:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);

const DownIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M4.293 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z",
      fill: "#212121"
    })
  });
};

exports.DownIcon = DownIcon;


/***/ }),

/***/ 994193:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);

const ListIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M3 17h18a1 1 0 0 1 .117 1.993L21 19H3a1 1 0 0 1-.117-1.993L3 17h18H3Zm0-6 18-.002a1 1 0 0 1 .117 1.993l-.117.007L3 13a1 1 0 0 1-.117-1.993L3 11l18-.002L3 11Zm0-6h18a1 1 0 0 1 .117 1.993L21 7H3a1 1 0 0 1-.117-1.993L3 5h18H3Z",
      fill: "currentColor"
    })
  });
};

exports.ListIcon = ListIcon;


/***/ }),

/***/ 695273:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);

const UpIcon = () => {
  return /* @__PURE__ */ jsxRuntime.jsx("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntime.jsx("path", {
      d: "M4.293 15.707a1 1 0 0 0 1.414 0L12 9.414l6.293 6.293a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 0 1.414Z",
      fill: "#212121"
    })
  });
};

exports.UpIcon = UpIcon;


/***/ }),

/***/ 275571:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var React = __webpack_require__(891987);
var context = __webpack_require__(430272);
var UpIcon = __webpack_require__(695273);
var DownIcon = __webpack_require__(998439);
var menu = __webpack_require__(712797);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const MenuItemTile = ({ item }) => {
  var _a, _b;
  const { isEditingMode = false } = context.useOmniHeader();
  const [open, setOpen] = React.useState(false);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(MenuItemWrapper, {
        onClick: () => setOpen(!open),
        children: [
          /* @__PURE__ */ jsxRuntime.jsxs(TitleWrapper, {
            href: menu.getUrlOfMenuItem(item, isEditingMode),
            children: [
              (item == null ? void 0 : item.iconUrl) && /* @__PURE__ */ jsxRuntime.jsx("img", {
                src: item == null ? void 0 : item.iconUrl,
                width: 18,
                height: 18,
                alt: item == null ? void 0 : item.name
              }),
              item == null ? void 0 : item.name
            ]
          }),
          ((_a = item == null ? void 0 : item.children) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ jsxRuntime.jsx("div", {
            children: open ? /* @__PURE__ */ jsxRuntime.jsx(UpIcon.UpIcon, {}) : /* @__PURE__ */ jsxRuntime.jsx(DownIcon.DownIcon, {})
          })
        ]
      }),
      open && /* @__PURE__ */ jsxRuntime.jsx("div", {
        style: { paddingLeft: "2em" },
        children: (_b = item == null ? void 0 : item.children) == null ? void 0 : _b.map((item2) => /* @__PURE__ */ jsxRuntime.jsx(MenuItemTile, {
          item: item2
        }))
      })
    ]
  });
};
const MenuItemWrapper = styled__default["default"].div`
  cursor: pointer;
  color: black;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0 0.5rem;
  overflow: hidden;
  padding: 10px 16px;
  border-top: 1px solid #eeeeee;

  a {
    color: black;
  }
`;
const TitleWrapper = styled__default["default"].a`
  display: flex;
  align-items: center;
  gap: 0.5em;
`;

exports.MenuItemTile = MenuItemTile;
exports.MenuItemWrapper = MenuItemWrapper;


/***/ }),

/***/ 29276:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var context = __webpack_require__(430272);
var CloseIcon = __webpack_require__(174121);
var MenuItemTile = __webpack_require__(275571);
var menu = __webpack_require__(712797);
var coreRenderer = __webpack_require__(327723);
var Link = __webpack_require__(688701);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MobileDrawer = ({ setMenuOpen, topBarMenu = [] }) => {
  const { menu: menu$1 = [] } = context.useOmniHeader();
  const tree = menu.flattenToTree((menu$1 || []).filter((el) => !el.isHidden));
  return /* @__PURE__ */ jsxRuntime.jsxs(Drawer, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsxs(Menu, {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx("div", {
            style: {
              display: "flex",
              padding: "1em"
            },
            children: /* @__PURE__ */ jsxRuntime.jsx(CloseDrawer, {
              onClick: () => setMenuOpen(false),
              children: /* @__PURE__ */ jsxRuntime.jsx(CloseIcon.CloseIcon, {})
            })
          }),
          tree == null ? void 0 : tree.map((item, index) => /* @__PURE__ */ jsxRuntime.jsx(MenuItemTile.MenuItemTile, {
            item
          }, index))
        ]
      }),
      /* @__PURE__ */ jsxRuntime.jsx(TopBarMenu, {
        children: topBarMenu == null ? void 0 : topBarMenu.map(({ event, icon, title }, index) => /* @__PURE__ */ React.createElement(StyledLink, __spreadProps(__spreadValues({}, event), {
          key: index
        }), /* @__PURE__ */ jsxRuntime.jsxs(TopBarItem, {
          children: [
            (icon == null ? void 0 : icon.src) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadProps(__spreadValues({}, icon), {
              commonStyle: {
                width: 18,
                height: 18
              }
            })),
            title
          ]
        })))
      })
    ]
  });
};
const Menu = styled__default["default"].div`
  background-color: white;
`;
const TopBarMenu = styled__default["default"].div`
  background-color: white;
  margin-top: 1em;
`;
const Drawer = styled__default["default"].div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f8f8fc;
  z-index: 1060;
`;
const CloseDrawer = styled__default["default"].div`
  display: inline-block;
  cursor: pointer;
  margin-left: auto;
`;
const StyledLink = styled__default["default"](Link.Link)`
  display: flex;
`;
const TopBarItem = styled__default["default"].div`
  cursor: pointer;
  color: black;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  overflow: hidden;
  padding: 10px 16px;
  border-top: 1px solid #eeeeee;

  a {
    color: black;
  }
`;

exports.MobileDrawer = MobileDrawer;


/***/ }),

/***/ 562204:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const MobileSearchBar = ({
  searchSlot,
  rightItemsSlot,
  isRightItemsVisible,
  backButtonHeaderMobile
}) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    children: [
      !!backButtonHeaderMobile && backButtonHeaderMobile,
      searchSlot,
      isRightItemsVisible && rightItemsSlot
    ]
  });
};
const Wrapper = styled__default["default"].div`
  margin: 0 1rem;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  & > *:not(:first-child) {
    margin-left: 1rem;
  }
`;

exports.MobileSearchBar = MobileSearchBar;


/***/ }),

/***/ 904112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var React = __webpack_require__(891987);
var useIntersectionObserver = __webpack_require__(978044);
var coreRenderer = __webpack_require__(327723);
var context = __webpack_require__(430272);
var MobileDrawer = __webpack_require__(29276);
var MobileSearchBar = __webpack_require__(562204);
var renderDynamicSlot = __webpack_require__(744175);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniMobileHeader = (_a) => {
  var _b = _a, {
    ssrData
  } = _b, rest = __objRest(_b, [
    "ssrData"
  ]);
  const { isEditingMode = false } = context.useOmniHeader();
  const { topBarMenu = [], logoMobile } = rest || {};
  const { mappingDynamicSlots, globalData } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(
    rest,
    "mobile"
  ), { primaryColor, commonStyle } = _a2, others = __objRest(_a2, ["primaryColor", "commonStyle"]);
  const [isMenuOpen, setMenuOpen] = React__default["default"].useState(false);
  const headerRef = React.useRef(null);
  const [isVisible] = useIntersectionObserver.useIntersectionObserver({
    elementRef: headerRef,
    threshold: 0
  });
  const searchSlot = renderDynamicSlot.renderDynamicSlot(
    `header_search_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  const searchBarRightItemsSlot = renderDynamicSlot.renderDynamicSlot(
    `search_bar_right_items_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  const backButtonHeaderMobile = renderDynamicSlot.renderDynamicSlot(
    `back_button_header_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  const headerRightItemsSlot = renderDynamicSlot.renderDynamicSlot(
    `header_right_items_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  const locationPickerHeaderMobile = renderDynamicSlot.renderDynamicSlot(
    `location_picker_header_mobile`,
    mappingDynamicSlots,
    ssrData
  );
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      isMenuOpen && /* @__PURE__ */ jsxRuntime.jsx(MobileDrawer.MobileDrawer, {
        setMenuOpen,
        topBarMenu
      }),
      !backButtonHeaderMobile && /* @__PURE__ */ jsxRuntime.jsx(Wrapper, __spreadProps(__spreadValues({
        ref: headerRef,
        primaryColor,
        commonStyle
      }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsxs(NavigationBar, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsxs(LogoWrapper, {
              children: [
                false,
                (logoMobile == null ? void 0 : logoMobile.src) && /* @__PURE__ */ jsxRuntime.jsx(Logo, {
                  href: isEditingMode ? null : "/",
                  children: (globalData == null ? void 0 : globalData.isHomepage) ? /* @__PURE__ */ jsxRuntime.jsx("h1", {
                    children: /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({}, logoMobile))
                  }) : /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, __spreadValues({}, logoMobile))
                })
              ]
            }),
            headerRightItemsSlot
          ]
        })
      })),
      /* @__PURE__ */ jsxRuntime.jsx(SearchBarWrapper, __spreadProps(__spreadValues({
        primaryColor,
        isEditingMode
      }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(MobileSearchBar.MobileSearchBar, {
          searchSlot,
          rightItemsSlot: searchBarRightItemsSlot,
          isRightItemsVisible: !isVisible,
          backButtonHeaderMobile
        })
      })),
      locationPickerHeaderMobile
    ]
  });
};
const Wrapper = styled__default["default"].header(
  ({ commonStyle, primaryColor }) => `
  position: relative; 
  background-color: ${primaryColor};
  ${coreRenderer.getStyle(commonStyle)}
        `
);
const NavigationBar = styled__default["default"].nav`
  display: flex;
  padding: 8px 16px 0 16px;
  color: white;
  justify-content: space-between;
  align-items: center;
`;
const SearchBarWrapper = styled__default["default"].div(
  ({ primaryColor, isEditingMode }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
  background: ${primaryColor};
  position: sticky;
  top: 0;
  margin-bottom: 8px;
  ${isEditingMode ? "" : "z-index: 1040;"}
`
);
styled__default["default"].div`
  margin-right: 0.5em;
  cursor: pointer;
`;
const Logo = styled__default["default"].a`
  user-select: none;
`;
const LogoWrapper = styled__default["default"].div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

exports.OmniMobileHeader = OmniMobileHeader;


/***/ }),

/***/ 182506:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var coreRenderer = __webpack_require__(327723);
var useMediaQuery = __webpack_require__(670387);
var context = __webpack_require__(430272);
var OmniMobileHeader = __webpack_require__(904112);
var OmniDesktopHeader = __webpack_require__(920659);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const OmniHeader = (props) => {
  const { isEditingMode } = props;
  const { device, globalData } = coreRenderer.useStore();
  const menu = isEditingMode ? props == null ? void 0 : props.menu : (globalData == null ? void 0 : globalData.menu) || [];
  const isMobile = useMediaQuery.useMediaQuery("(max-width: 768px)");
  const renderByDevice = () => {
    if (device === "mobile" || isMobile)
      return /* @__PURE__ */ jsxRuntime.jsx(OmniMobileHeader.OmniMobileHeader, __spreadProps(__spreadValues({}, props), {
        menu
      }));
    return /* @__PURE__ */ jsxRuntime.jsx(OmniDesktopHeader.OmniDesktopHeader, __spreadProps(__spreadValues({}, props), {
      menu
    }));
  };
  return /* @__PURE__ */ jsxRuntime.jsx(context.OmniHeaderProvider, {
    value: { menu, isEditingMode },
    children: renderByDevice()
  });
};
OmniHeader.displayName = "Omni_Header";

exports.OmniHeader = OmniHeader;


/***/ }),

/***/ 507644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(225956);
var coreRenderer = __webpack_require__(327723);
var Container = __webpack_require__(739890);
var renderDynamicSlot = __webpack_require__(744175);
var grid = __webpack_require__(793767);
var BlockHeader = __webpack_require__(177530);
var renderLink = __webpack_require__(62534);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniProductList = (_a) => {
  var _b = _a, {
    ssrData,
    isEditingMode
  } = _b, restProps = __objRest(_b, [
    "ssrData",
    "isEditingMode"
  ]);
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    collectionSlug,
    commonStyle,
    title,
    titleStyle,
    viewMoreUrl,
    viewMoreStyle
  } = _a2, rest = __objRest(_a2, [
    "collectionSlug",
    "commonStyle",
    "title",
    "titleStyle",
    "viewMoreUrl",
    "viewMoreStyle"
  ]);
  const _b2 = commonStyle || {}, { padding, margin } = _b2, restStyle = __objRest(_b2, ["padding", "margin"]);
  const renderViewAllLink = () => {
    if (!viewMoreUrl)
      return null;
    const content = /* @__PURE__ */ jsxRuntime.jsxs(ViewAll, {
      commonStyle: viewMoreStyle,
      children: [
        "Xem t\u1EA5t c\u1EA3 ",
        /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
          name: "RightOutlined"
        })
      ]
    });
    return renderLink.renderLink(viewMoreUrl, content, isEditingMode);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth: grid.DEFAULT_MAX_WIDTH, padding, margin }
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: restStyle,
      children: [
        !!title && /* @__PURE__ */ jsxRuntime.jsxs(Header, {
          device,
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
              commonStyle: titleStyle,
              children: title
            }),
            renderViewAllLink()
          ]
        }),
        renderDynamicSlot.renderDynamicSlot(
          `product_grid_${device}`,
          mappingDynamicSlots,
          ssrData,
          {
            collectionSlug,
            config: {
              regionName: "forYouListProduct"
            }
          }
        )
      ]
    })
  }));
};
OmniProductList.displayName = "Omni_ProductList";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  border-radius: 0.5rem;
  background: #ffffff;
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const Header = styled__default["default"](BlockHeader.BlockHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledTitle = styled__default["default"].div(
  ({ commonStyle }) => `
  flex: 1;
  margin-right: 8px;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const ViewAll = styled__default["default"].div(
  ({ commonStyle }) => `
  display: flex;
  align-items: center;
  ${coreRenderer.getStyle(commonStyle)}
`
);

exports.OmniProductList = OmniProductList;


/***/ }),

/***/ 830533:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const DEFAULT_RADIUS = 16;
const PRODUCT_WRAPPER_PADDING = 8;
const DEFAULT_PRODUCT_SLIDER_WITH_BANNER_WEB = {
  syncDeviceStyle: true,
  responsive: { hiddenMd: true },
  mobile: {
    titleStyle: { color: "#ffffff", background: "#0200BC" },
    viewMoreStyle: { color: "#ffffff" },
    blockStyle: { background: "#0200BC" }
  },
  desktop: {
    titleStyle: { color: "#ffffff", background: "#0200BC" },
    viewMoreStyle: { color: "#ffffff" },
    blockStyle: { background: "#0200BC" }
  },
  title: "Product Slider Title",
  maxWidth: 1600,
  radius: DEFAULT_RADIUS
};

exports.DEFAULT_PRODUCT_SLIDER_WITH_BANNER_WEB = DEFAULT_PRODUCT_SLIDER_WITH_BANNER_WEB;
exports.DEFAULT_RADIUS = DEFAULT_RADIUS;
exports.PRODUCT_WRAPPER_PADDING = PRODUCT_WRAPPER_PADDING;


/***/ }),

/***/ 765838:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var icons = __webpack_require__(225956);
var coreRenderer = __webpack_require__(327723);
var constants = __webpack_require__(830533);
var Container = __webpack_require__(739890);
var grid = __webpack_require__(793767);
var BlockHeader = __webpack_require__(177530);
var Row = __webpack_require__(607933);
var renderLink = __webpack_require__(62534);
var renderDynamicSlot = __webpack_require__(744175);
var getStyles = __webpack_require__(523340);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductSliderWithBannerWeb = (_a) => {
  var _b = _a, {
    isEditingMode = false,
    banners = [],
    title,
    ssrData,
    viewMoreUrl
  } = _b, restProps = __objRest(_b, [
    "isEditingMode",
    "banners",
    "title",
    "ssrData",
    "viewMoreUrl"
  ]);
  var _b2;
  const { device, mappingDynamicSlots } = coreRenderer.useStore();
  const _a2 = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    titleStyle,
    viewMoreStyle,
    maxWidth,
    radius = constants.DEFAULT_RADIUS,
    blockStyle,
    collectionSlug
  } = _a2, rest = __objRest(_a2, [
    "commonStyle",
    "titleStyle",
    "viewMoreStyle",
    "maxWidth",
    "radius",
    "blockStyle",
    "collectionSlug"
  ]);
  const viewMoreContent = /* @__PURE__ */ jsxRuntime.jsxs(StyledViewAll, {
    color: viewMoreStyle == null ? void 0 : viewMoreStyle.color,
    children: [
      "Xem t\u1EA5t c\u1EA3",
      " ",
      /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
        name: "RightOutlined",
        color: viewMoreStyle == null ? void 0 : viewMoreStyle.color,
        style: {
          fontSize: 20
        }
      })
    ]
  });
  const hasBanner = banners && banners.length > 0;
  const innerBorderRadius = radius - constants.PRODUCT_WRAPPER_PADDING;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: __spreadValues({
      maxWidth
    }, commonStyle)
  }, rest), {
    maxWidth: maxWidth || grid.DEFAULT_MAX_WIDTH_1600,
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      radius,
      children: [
        (isEditingMode || !isEditingMode && hasBanner) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
          isEditingMode,
          src: hasBanner ? (_b2 = banners[0]) == null ? void 0 : _b2.src : "https://lh3.googleusercontent.com/5j_eWpVbAWOPHpd5RCylcaFR6cg0bFFDjFqYnh0ASIsEJScCiLfafyAI6lkToXn-ihjJEQCkWSX-pW2C-7ZW6qxwJhsGcY8",
          alt: "Image",
          commonStyle: { objectFit: "contain", width: "100%" }
        }),
        /* @__PURE__ */ jsxRuntime.jsx(HeaderWrapper, {
          commonStyle: __spreadValues(__spreadValues({}, titleStyle), hasBanner ? { borderRadius: 0 } : {
            borderRadius: `${radius}px ${radius}px 0 0`
          }),
          children: /* @__PURE__ */ jsxRuntime.jsx(BlockHeader.BlockHeader, {
            device,
            children: /* @__PURE__ */ jsxRuntime.jsxs(Row.Row, {
              justify: "space-between",
              children: [
                /* @__PURE__ */ jsxRuntime.jsx(StyledTitle, {
                  color: titleStyle == null ? void 0 : titleStyle.color,
                  children: title
                }),
                !!viewMoreUrl && /* @__PURE__ */ jsxRuntime.jsx("div", {
                  children: renderLink.renderLink(viewMoreUrl, viewMoreContent, isEditingMode)
                })
              ]
            })
          })
        }),
        /* @__PURE__ */ jsxRuntime.jsx(ProductWrapper, {
          commonStyle: blockStyle,
          radius,
          children: /* @__PURE__ */ jsxRuntime.jsx("div", {
            style: {
              flexGrow: 1,
              width: "100%",
              backgroundColor: "#fff",
              borderRadius: `${innerBorderRadius >= 0 ? innerBorderRadius : 0}px`,
              padding: 8
            },
            children: renderDynamicSlot.renderDynamicSlot(
              `new_layout_product_carousel_${device}`,
              mappingDynamicSlots,
              ssrData,
              { collectionSlug, config: { maxWidth } }
            )
          })
        })
      ]
    })
  }));
};
const Wrapper = styled__default["default"].div(
  ({ radius }) => `
  position: relative;
  overflow: hidden;
  border-radius: ${radius}px;
`
);
const HeaderWrapper = styled__default["default"].div(
  ({ commonStyle }) => getStyles.getStyle(commonStyle)
);
const StyledTitle = styled__default["default"].div(
  ({ color }) => `
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  transition: color 0.3s ease 0s;
  color: ${color}
`
);
const StyledViewAll = styled__default["default"].div(
  ({ color }) => `
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  transition: color 0.3s ease 0s;
  color: ${color}
`
);
const ProductWrapper = styled__default["default"].div(
  ({ radius, commonStyle }) => `
  flex-grow: 1;
  width: 100%;
  border-radius: 0 0 ${radius}px ${radius}px;
  padding: ${constants.PRODUCT_WRAPPER_PADDING}px;
  color: unset !important;
  ${getStyles.getStyle(commonStyle)},
`
);
ProductSliderWithBannerWeb.displayName = "omni_productsliderwithbanner_web";

exports.ProductSliderWithBannerWeb = ProductSliderWithBannerWeb;


/***/ })

}]);